import { ObservableArray, View } from "binder"
import { ThemeSelectorViewModel } from "src/common/themeSelector/themeSelector-viewModel";
import { AccessibleFormViewModel, FavoriteFilter, FilterAccessibleFormsViewModel, UserMainWindowViewModel } from "../userMainWindow-viewModel";
import { WindowContainerViewModel } from "../windowContainer/windowContainer-viewModel";
import { NotificationsPopupViewModel } from "../notifications/notificationsPopup/notificationsPopup-viewModel";

export class UserMainWindowPhoneView extends View<UserMainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-09A457C1-2847-437E-9591-AC22A407B3EC"
    }
    loadHtml(): string {
        let element = require('./userMainWindowPhone.html').default;
        let style = require('./userMainWindowPhone.less');
        return element;
    }
    constructor() {
       super();
       this.thisClickedHandler = this.thisClicked.bind(this);
       this.windowClickedHandler = this.windowClicked.bind(this); 
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms;} private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) { 
        this._currentForm = v; 
        this.isShowingMenu = false;
        if(this.currentForm!=null && this.forms.length>1){
            this.forms.shift();
        }
    } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter;} private _filter: FilterAccessibleFormsViewModel;
    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName;} private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode;} private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide;} private _autohide: boolean;

    public set isShowingMenu(v: boolean) { this._isShowingMenu = v;this.updateEvents(); } public get isShowingMenu(): boolean { return this._isShowingMenu;} private _isShowingMenu: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow;} private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes;} private _shallShowThemes: boolean;
    
    public set favorites(v: ObservableArray<AccessibleFormViewModel>) { this._favorites = v; } public get favorites(): ObservableArray<AccessibleFormViewModel> { return this._favorites;} private _favorites: ObservableArray<AccessibleFormViewModel>;
    public set hasFavorites(v: boolean) { this._hasFavorites = v; } public get hasFavorites(): boolean { return this._hasFavorites;} private _hasFavorites: boolean;
    public set favoriteFilter(v: FavoriteFilter) { this._favoriteFilter = v; } public get favoriteFilter(): FavoriteFilter { return this._favoriteFilter;} private _favoriteFilter: FavoriteFilter;
    public set showFavorites(v: boolean) { this._showFavorites = v; } public get showFavorites(): boolean { return this._showFavorites;} private _showFavorites: boolean;
    public set shallShowInstall(v: boolean) { this._shallShowInstall = v; } public get shallShowInstall(): boolean { return this._shallShowInstall;} private _shallShowInstall: boolean;
    public set userNotificationsPopup(v: NotificationsPopupViewModel) { this._userNotificationsPopup = v; } public get userNotificationsPopup(): NotificationsPopupViewModel { return this._userNotificationsPopup;} private _userNotificationsPopup: NotificationsPopupViewModel;
    public set applicationTitle(v: string) { this._applicationTitle = v; } public get applicationTitle(): string { return this._applicationTitle;} private _applicationTitle: string;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture;} private _hasPicture: boolean;
    public set pictureFileName(v: string) { this._pictureFileName = v; } public get pictureFileName(): string { return this._pictureFileName; } private _pictureFileName: string;
    public set pictureFileData(v: string) { this._pictureFileData = v; } public get pictureFileData(): string { return this._pictureFileData; } private _pictureFileData: string;
    public set ourSystemName(v: string) { this._ourSystemName = v; } public get ourSystemName(): string { return this._ourSystemName;} private _ourSystemName: string;
    
    toggleShowing(e:PointerEvent){
        this.isShowingMenu = !this.isShowingMenu;
        if(this.isShowingMenu){
            e?.stopPropagation();
        }
    }

    private thisClicked(e:PointerEvent){
        e.stopPropagation();
    }
    private windowClicked(e:PointerEvent){
        this.isShowingMenu = false;
        e.stopPropagation();
    }
    private thisClickedHandler;
    private windowClickedHandler;
    private menu:HTMLElement;
    updateEvents(){
        if(this.isShowingMenu){
            window.addEventListener("click",e=>this.windowClickedHandler(e));
            this.menu.addEventListener("click",e=>this.thisClickedHandler(e));

        }else{
            window.removeEventListener("click",this.windowClickedHandler);
            this.menu?.removeEventListener("click",this.thisClickedHandler);
        }
    }
    
    public onRenderCompleted() {
        this.menu = this.firstlevelElement.querySelector('.V-09A457C1-2847-437E-9591-AC22A407B3EC.menu');
        this.isShowingMenu = false;
    }
    
    showThemeWindow(){
        this.isShowingMenu = false;
        this.dataContext.showThemeWindow();
    }

    toggleShowFavorite(){
        this.dataContext.toggleShowFavorite();
    }

    install(){
        this.dataContext.install();
    }
}
